/** Shared between the submission wizard's document step and the claim-detail upload panel. */
export const DOCUMENT_TYPES = [
  { value: "death_certificate", label: "Death Certificate" },
  { value: "medical_report", label: "Medical Report" },
  { value: "id_document", label: "Identification Document" },
  { value: "bank_details", label: "Bank Details" },
  { value: "police_report", label: "Police Report" },
  { value: "other", label: "Other Supporting Document" },
];

export default DOCUMENT_TYPES;
